import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EditorModule, EditorTextChangeEvent } from 'primeng/editor';
import { FormsModule } from '@angular/forms';

export interface EditorContent
{
  textValue:string,
  htmlValue:string
}

@Component({
  selector: 'app-content-editor',
  standalone: true,
  imports: [EditorModule, FormsModule],
  templateUrl: './content-editor.component.html',
  styleUrl: './content-editor.component.scss',
})
export class ContentEditorComponent {
  @Input() htmlContent!: string;
  @Input() style: any = { height: '320px' };
  @Output() onContentChange: EventEmitter<EditorContent>=new EventEmitter<EditorContent>;

  setContent($event: EditorTextChangeEvent) {
    this.onContentChange?.emit({
      textValue:$event.textValue,
      htmlValue:$event.htmlValue
    });
  }
}
